import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Inventario" },
  { label: "Inventario General",   icon: "fas fa-warehouse",     color: "#10b981", bg: "#f0fdf4", href: "/ListadoInventarios",        desc: "Vista principal con filtros",   permOr: ["inventarios", "inventario_cedis", "inventario_tiktok"] },
  { label: "Inventario Bodega",    icon: "fas fa-warehouse",     color: "#22c55e", bg: "#f0fdf4", href: "/ListadoInventariosBodega",  desc: "Vista sin filtros extra",      perm: "inventarios" },
  { label: "Inventario Disponible", icon: "fas fa-tasks",        color: "#3b82f6", bg: "#eff6ff", href: "/MenuDisponibles",           desc: "Stock disponible por área",     permOr: ["menu_disponible", "menu_disponibleIciqlo", "menu_disponibleV1per"] },
  { label: "Reporte Stock",        icon: "fas fa-warehouse",     color: "#0ea5e9", bg: "#f0f9ff", href: "/ListadoInventariosStock",   desc: "Stock consolidado",             perm: "inventarios" },

  { type: "section", label: "Trazabilidad" },
  { label: "Tracking",             icon: "fas fa-search",           color: "#6366f1", bg: "#eef2ff", href: "/ListadoTracking",  desc: "Seguimiento de movimientos", perm: "seguimiento_inventarios" },
  { label: "Kardex",               icon: "fas fa-clipboard-list",   color: "#8b5cf6", bg: "#f5f3ff", href: "/ListadoKardex",    desc: "Movimientos por artículo",   perm: "seguimiento_inventarios" },
  // Ya no hay lotes (todo el inventario es "NA")
  // { label: "Lotes por Articulo",   icon: "fas fa-thumbtack",        color: "#a855f7", bg: "#faf5ff", href: "/ListadoLotes",     desc: "Lotes agrupados",            perm: "menu_inventarios" },
  // { label: "Lotes",                icon: "fas fa-map-marked-alt",   color: "#ec4899", bg: "#fdf2f8", href: "/ListadoLotes2",    desc: "Detalle de lotes",           perm: "menu_inventarios" },

  { type: "section", label: "Movimientos" },
  { label: "Nuevo Traspaso",       icon: "fas fa-exchange-alt", color: "#f59e0b", bg: "#fffbeb", href: "/TraspasosSalidaCreate",     desc: "Salida + entrada en 1 paso", perm: "menu_traspasos_salida" },
  { label: "Listado Traspasos",    icon: "fas fa-sign-out-alt", color: "#eab308", bg: "#fefce8", href: "/ListadoTraspasosSalida",    desc: "Traspasos ya realizados",    perm: "menu_traspasos_salida" },
  { label: "Reporte Traspasos",    icon: "fas fa-list-alt",     color: "#f97316", bg: "#fff7ed", href: "/ReporteArticulosTraspaso",  desc: "Reporte por artículo",       perm: "menu_traspasos_entrada" },
  { label: "Ajuste Inventario",    icon: "fas fa-plus",         color: "#ef4444", bg: "#fef2f2", href: "/ListadoAjustesInventario",  desc: "Alta/baja manual",           perm: "ajustesInventario" },

  { type: "section", label: "Catálogo" },
  { label: "Almacenes",            icon: "fas fa-warehouse",    color: "#64748b", bg: "#f1f5f9", href: "/Areas",                     desc: "Áreas y almacenes",          perm: "inventarios" },
];

function BotonesInventarios() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-boxes" color="#10b981" bg="#f0fdf4" title="Inventarios" subtitle="Stock, trazabilidad y movimientos" />
        {user.menu_inventarios ? (
          <div className="row">
            {ITEMS.map((r, i) => {
              if (r.type === "section") return <MenuSection key={i} title={r.label} />;
              const enabled = r.permOr ? r.permOr.some((p) => !!user[p]) : !!user[r.perm];
              return <MenuCard key={i} {...r} enabled={enabled} />;
            })}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesInventarios;
